import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LedControlService {

  // LED Green
  async signalAvailable() {
    try {
      await (await fetch('http://localhost:8088/led/static?color=GREEN')).text();
    } catch (error) {
      console.log('FETCH ERROR: ', (error as any)?.message);
      // handleRequestError(error, this.#injector, { show: true });
    }
  }

  // LED Blue
  async signalOccupied() {
    try {
      await (await fetch('http://localhost:8088/led/static?color=BLUE')).text();
    } catch (error) {
      console.log('FETCH ERROR: ', (error as any)?.message);
      // handleRequestError(error, this.#injector, { show: true });
    }
  }

  // LED Red FLASH
  async signalAssistance() {
    try {
      await (await fetch('http://localhost:8088/led/flash?color=RED')).text();
    } catch (error) {
      console.log('FETCH ERROR: ', (error as any)?.message);
      // handleRequestError(error, this.#injector, { show: true });
    }
  }

  // LED Red
  async signalCashier() {
    try {
      await (await fetch('http://localhost:8088/led/static?color=RED')).text();
    } catch (error) {
      console.log('FETCH ERROR: ', (error as any)?.message);
      // handleRequestError(error, this.#injector, { show: true });
    }
  }

  // LED Off
  async signalOver() {
    try {
      await (await fetch('http://localhost:8088/led/off', {})).text();
    } catch (error) {
      console.log('FETCH ERROR: ', (error as any)?.message);
      // handleRequestError(error, this.#injector, { show: true });
    }
  }
}
